import Vue from 'vue';

Vue.component('vuetable_changeset_pricebook', () =>
    import(/* webpackChunkName: 'pricebook-change-set' */ './pricebook-change-set.vue'),
);

Vue.component('vuechangeset', () =>
    import(/* webpackChunkName: 'pricebook-change-set' */ './changeset-details.vue'),
);

Vue.component('vuechangesetproduct', () =>
    import(/* webpackChunkName: 'pricebook-change-set' */ './changeset-station-product.vue'),
);
